/**
 * Created by mukund on 1/18/18.
 *
 * AngularJS directive for Scheduler Event Form
 */

'use strict';

angular.module('mediacloudApp')
    .directive('schedulerEventForm', ['$filter', '$log', '$timeout', 'Tenant', 'CollectionService', 'SchedulerService', 'Principal', function($filter, $log, $timeout, Tenant, CollectionService, SchedulerService, Principal){

        return {
            restrict: 'E',
            replace: true,
            templateUrl: 'scripts/components/collection/directives/scheduler-event-form/scheduler-event-form.html',
            scope: {
                parent: '=',
                formType: '=',
                editableEvent: '=',
                toggleEventForm: '&',
                contributors: '=',
                hasEvents: '=',
                reset: '&',
                allowScheduling: '=',
                timezoneDefault: '='
            },
            link: function(scope, element, attr) {

                // Tenant Info
                Tenant.info().then(function (data) {
                    if(data) {
                        scope.tenantId = data.id;
                        scope.showUserFullName = data.showUserFullName;
                    }

                });

                // username code
                var userInfo = Principal.getUserInfo();
                scope.userName = userInfo.userName;
                scope.userFullName = userInfo.userFullName;

                scope.recurring = false;
                scope.loaded = false;
                scope.showRecurringOptions = false;

                scope.recurringMeetingType = '1';
                scope.repeatIntervalOptionsOriginal = Array.from({length: 15}, (_, i) => i + 1);
                scope.repeatIntervalOptions = scope.repeatIntervalOptionsOriginal;

                //monthly
                scope.monthly_day = 1;
                scope.monthly_week = '1';
                scope.monthly_week_day = '1';
                scope.monthlyType = '1';
                scope.monthDayOpts = Array.from({length: 31}, (_, i) => i + 1);

                scope.repeatInterval = scope.repeatIntervalOptions[0];
                scope.initRecurrenceDate = new Date().clearSeconds();
                scope.recurrenceDate = new Date().clearSeconds();
                scope.recurrenceDate.setDate(scope.initRecurrenceDate.getDate() + 7);
                scope.endTimes = 1;
                scope.endType = '1';

                scope.summaryText = '';

                SchedulerService.checkAvailability.get({baseCollectionId: scope.parent.cid}, function(response){
                    scope.allowScheduling = response.result;
                    if(scope.allowScheduling) {
                        $('#zoomButton').hide();
                    }
                    else {
                        $('#zoomButton').show();
                    }
                });

                // Config used by datepicker
                scope.dateTimePicker = SchedulerService.getDateTimePicker();
                var newEventDatePickerConfig = JSON.parse(JSON.stringify(scope.dateTimePicker.config));

                var recNewEventDatePickerConfig = JSON.parse(JSON.stringify(scope.dateTimePicker.config));
                recNewEventDatePickerConfig.minDate = new Date().addHours(24*7),

                scope.recurrenceConfig = {
                    dateTimeOptions: {
                        date: new Date().addHours(24*7),
                        startDate: new Date().addHours(24*7),
                        endDate: new Date().addHours(24*8),
                        min: new Date().addHours(24*7),
                        timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                        config: recNewEventDatePickerConfig
                    }
                }
                $('#recurrence-date-picker').val(moment(scope.recurrenceDate).format('MM/DD/YYYY'));
                $('#event-title-form-field').focus();

               scope.getSummaryText = function (changeRecurrenceDate) {
                    var type = 'day';
                    var val = $('#repeatInterval').val();
                    var repeatInterval = 1;
                    if (val) {
                        if (isNaN(val)) {
                            repeatInterval = parseInt(val.replace('number:', ''));
                        }
                        else {
                            repeatInterval = parseInt(val);
                        }
                    }

                    if (scope.recurringMeetingType === '1') {
                        type = 'day';
                        if (changeRecurrenceDate) {
                            recNewEventDatePickerConfig.minDate = new Date().addHours(24*6*repeatInterval);
                            scope.recurrenceConfig = {
                                dateTimeOptions: {
                                    date: new Date().addHours(24*6*repeatInterval),
                                    startDate: new Date().addHours(24*6*repeatInterval),
                                    endDate: new Date().addHours(24*7*repeatInterval),
                                    min: new Date().addHours(24*6*repeatInterval),
                                    timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                    config: recNewEventDatePickerConfig
                                }
                           }
                          scope.recurrenceDate = new Date().addHours(24*6*repeatInterval);
                      }
                    }
                    else if (scope.recurringMeetingType === '2') {
                        type = 'week';
                        if (changeRecurrenceDate) {
                            recNewEventDatePickerConfig.minDate = new Date().addHours(24*7*7*repeatInterval);
                            scope.recurrenceConfig = {
                                dateTimeOptions: {
                                    date: new Date().addHours(24*6*7*repeatInterval),
                                    startDate: new Date().addHours(24*6*7*repeatInterval),
                                    endDate: new Date().addHours(24*7*7*repeatInterval),
                                    min: new Date().addHours(24*6*7*repeatInterval),
                                    timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                    config: recNewEventDatePickerConfig
                                }
                            }
                           scope.recurrenceDate = new Date().addHours(24*6*7*repeatInterval);
                       }
                    }
                    else if (scope.recurringMeetingType === '3') {
                        type = 'month';
                        if (changeRecurrenceDate) {
                            recNewEventDatePickerConfig.minDate = new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval));
                            scope.recurrenceConfig = {
                                dateTimeOptions: {
                                    date: new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval)),
                                    startDate: new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval)),
                                    endDate: new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval)),
                                    min: new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval)),
                                    timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                    config: recNewEventDatePickerConfig
                                }
                            }
                           scope.recurrenceDate = new Date(new Date().setMonth(new Date().getMonth()+6*repeatInterval));
                       }
                    }
                    else {
                        type = 'days';
                    }
                    if (repeatInterval > 1) {
                        type = repeatInterval + ' ' + type + 's';
                    }
                    $('#summaryText').text('Recur every ' + type + ' from ' + $('#event-date-picker').val() + ' until ' + $('#recurrence-date-picker').val());
               };

                scope.recurringMeetingTypeChange = () => {
                    console.log('current val: ' + scope.recurringMeetingType);
                    scope.recurringMeetingType = $("#recurringMeetingType").val();
                    if (scope.recurringMeetingType === '1') {
                        recNewEventDatePickerConfig.minDate = new Date().addHours(24*7);
                        scope.recurrenceConfig = {
                            dateTimeOptions: {
                                date: new Date().addHours(24*7),
                                startDate: new Date().addHours(24*7),
                                endDate: new Date().addHours(24*8),
                                min: new Date().addHours(24*7),
                                timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                config: recNewEventDatePickerConfig
                            }
                        }
                       scope.recurrenceDate = new Date().addHours(24*7);
                    }
                    else if (scope.recurringMeetingType === '2') {
                        recNewEventDatePickerConfig.minDate = new Date().addHours(24*7*7);
                        scope.recurrenceConfig = {
                            dateTimeOptions: {
                                date: new Date().addHours(24*7*7),
                                startDate: new Date().addHours(24*7*7),
                                endDate: new Date().addHours(24*8*7),
                                min: new Date().addHours(24*7*7),
                                timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                config: recNewEventDatePickerConfig
                            }
                        }
                       scope.recurrenceDate = new Date().addHours(24*7*7);
                    }

                    else if (scope.recurringMeetingType === '3') {
                        recNewEventDatePickerConfig.minDate = new Date(new Date().setMonth(new Date().getMonth()+6));
                        scope.recurrenceConfig = {
                            dateTimeOptions: {
                                date: new Date(new Date().setMonth(new Date().getMonth()+6)),
                                startDate: new Date(new Date().setMonth(new Date().getMonth()+6)),
                                endDate: new Date(new Date().setMonth(new Date().getMonth()+6)),
                                min: new Date(new Date().setMonth(new Date().getMonth()+6)),
                                timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                config: recNewEventDatePickerConfig
                            }
                        }
                       scope.recurrenceDate = new Date(new Date().setMonth(new Date().getMonth()+6));
                    }
                    else {
                       scope.recurrenceDate = new Date();
                   }

                   $('#recurrence-date-picker').val(moment(scope.recurrenceDate).format('MM/DD/YYYY'));
                   scope.getSummaryText();
                };

                var getRemoteDate = function(eventTime, remoteTimeZone) {
                    var date = new Date(eventTime),
                        localTime = date.getTime(), // ms
                        localOffset = date.getTimezoneOffset() * 60000, // min -> ms
                        utc = localTime + localOffset,
                        remoteOffset = moment().utcOffset(moment.tz(eventTime, remoteTimeZone).format()).utcOffset(), // min
                        remoteTime = utc + (remoteOffset * 60000); // min -> ms
                    return new Date(remoteTime);
                };

                scope.setCopyState = function() {
                    scope.showCopiedState = true;
                    $timeout(function(){
                        scope.showCopiedState = false;
                    }, 3000);
                };

                scope.$watch('recurringMeetingType', function(val) {
                    console.log('Changed!!: ', val)
                    if (val === '1') {
                        scope.repeatIntervalOptions = Array.from({length: 15}, (_, i) => i + 1);
                    }
                    if (val === '2') {
                        scope.repeatIntervalOptions = Array.from({length: 12}, (_, i) => i + 1);
                    }
                    if (val === '3') {
                        scope.repeatIntervalOptions = Array.from({length: 3}, (_, i) => i + 1);
                    }
                    $timeout(function () {
                        scope.repeatInterval = 1;
                        $('#repeatInterval').val('number:1')
                    }, 150);
                }, true);

                scope.appendS = function(sel, getSummaryText) {
                    console.log('repeatInterval: ', sel.repeatInterval);
                    var singular = parseInt(sel.repeatInterval, 10) === 1;
                    $('select[id="recurringMeetingType"] option').each(function () {
                        if (singular) {
                            $(this).text($(this).attr('data-single'));
                        } else {
                            $(this).text($(this).attr('data-other'));
                        }
                    });
                    scope.getSummaryText();
                };

                scope.$watch('recurring', function(val) {
                    if (val) {
                        $('form .eventTimeWrapper').hide()
                    }
                    else {
                        $('form .eventTimeWrapper').show();
                    }
                    if (scope.editableEvent && scope.loaded) {
                        if (scope.editableEvent.eventInfo.recurrence) {
                            var recurrence = scope.editableEvent.eventInfo.recurrence;
                            scope.showRecurringOptions = true;
                            scope.recurringMeetingType = recurrence.type.toString();
                            scope.repeatInterval = recurrence.repeat_interval;
                            $('#repeatInterval').val(recurrence.repeat_interval);
                            var date = moment.unix(recurrence.end_date_time).format('MM/DD/YYYY');
                            recNewEventDatePickerConfig.minDate = new Date(date);
                            scope.recurrenceConfig = {
                                dateTimeOptions: {
                                    date: new Date(date),
                                    startDate: new Date(date),
                                    endDate: new Date(date).addHours(1),
                                    min: new Date(date),
                                    timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                    config: recNewEventDatePickerConfig
                                }
                            }
                            scope.recurrenceDate = new Date(date);
                            $('#recurrence-date-picker').val(date);
                            $('#recurringMeetingType').val(recurrence.type.toString());
                            if (recurrence.type === 1) {

                            }
                            if (recurrence.type === 2 && recurrence.weekly_days) {
                                var weekly_days_arr = recurrence.weekly_days.split(',');
                                $timeout(function(){
                                    $.each($('#for-weekly input:checkbox'), (k, v) => {
                                        var value = $(v).val();
                                        if (weekly_days_arr.includes(value)) {
                                            $(v).attr('checked', true);
                                        }
                                    });
                                }, 500);
                            }
                            if (recurrence.type === 3) {
                                if (recurrence.monthly_day) {
                                    $timeout(function(){
                                        scope.monthly_day = recurrence.monthly_day;
                                    }, 500);
                                }
                                if (recurrence.monthly_week && recurrence.monthly_week_day) {
                                    $timeout(function(){
                                        scope.monthly_week = recurrence.monthly_week.toString();
                                        scope.monthly_week_day = recurrence.monthly_week_day.toString();
                                        scope.monthlyType = '2';
                                    }, 500);
                                }
                            }
                            $timeout(function(){
                                scope.repeatInterval = recurrence.repeat_interval;
                                $('#repeatInterval').val(recurrence.repeat_interval);
                                scope.appendS({repeatInterval: scope.repeatInterval}, false);
                                scope.getSummaryText(false);
                            }, 500);
                        }
                    }
                    else {
                        // scope.showRecurringOptions = val;
                        scope.showRecurringOptions = false;
                    }
                }, true);

                scope.save = function(){
                    console.log('recurring: ', scope.recurring);
                    var recurrence = {};
                    var meetingType = 2;
                    var endTime = moment(scope.event.dateTimeOptions.endDate).format("YYYY-MM-DD HH:mm:ss");
                    if(scope.recurring) {
                        meetingType = 3;
                        if ($('#showRecurringOptions:checked').val() === 'on') {
                            meetingType = 8;
                            recurrence.end_date_time = moment($('#recurrence-date-picker').val()).format("YYYY-MM-DD") + "T12:00:00Z";
                            var recurringMeetingType = scope.recurringMeetingType;
                            var repeatInterval = $('#repeatInterval').val().replace('number:', '');
                            recurrence.type = recurringMeetingType;
                            recurrence.repeat_interval = repeatInterval;
                            console.log('recurringMeetingType: ', recurringMeetingType);

                            // week
                            if (recurringMeetingType === '2') {
                                // get selected days and add them as a string ("1,4");
                                var weekly_days = [];
                                $.each($('#for-weekly input:checkbox:checked'), (k, v) => {
                                    console.log($(v).val())
                                    weekly_days.push($(v).val());
                                });
                                recurrence.weekly_days = weekly_days.join(",");
                            }
                            // monthly
                            if (recurringMeetingType === '3') {
                                var monthlyType = $('input[name="monthlyType"]:checked').val();
                                if (monthlyType  === '1') {
                                    recurrence.monthly_day = $('#monthly_day').val().replace('number:', '');
                                }
                                else {
                                    scope.monthlyType = '2';
                                    recurrence.monthly_week = $('#monthly_week').val();
                                    recurrence.monthly_week_day = $('#monthly_week_day').val();
                                }
                            }
                        }
                    }
                    if(scope.event.metadata.title){
                        if(scope.formType === 'add'){
                            var addEventRequest = {
                                title: scope.event.metadata.title,
                                contributor: scope.contributor.userId,
                                description: scope.event.metadata.description,
                                timeZone: scope.event.dateTimeOptions.timeZone.key,
                                startTime: moment(scope.event.dateTimeOptions.startDate).format("YYYY-MM-DD HH:mm:ss"),
                                endTime: endTime,
                                recurrence: meetingType === 8 ? recurrence : null
                            };
                            var addEventResource = SchedulerService.addEvent({
                                baseCollectionId: scope.parent.cid,
                                destinationCollectionId: scope.event.metadata.destination.cid,
                                meetingType: meetingType,
                                recordingOption: null
                            });
                            addEventResource.save(addEventRequest, function (response) {
                                if(!scope.hasEvents){
                                    scope.hasEvents = true;
                                }
                                scope.reset();
                            });
                        } else if(scope.formType === 'edit'){
                            var editEventRequest = {
                                eventId: scope.event.meetingOptions.meetingId,
                                meetingUuid: scope.event.meetingOptions.meetingUuid,
                                title: scope.event.metadata.title,
                                contributor: scope.contributor.userId,
                                description: scope.event.metadata.description,
                                destinationCollectionId: scope.event.metadata.destination.cid,
                                timeZone: scope.event.dateTimeOptions.timeZone.key,
                                startTime: moment(scope.event.dateTimeOptions.startDate).format("YYYY-MM-DD HH:mm:ss"),
                                endTime: endTime,
                                recurrence: meetingType === 8 ? recurrence : null
                            };
                            var editEventResource = new SchedulerService.editEvent({
                               meetingType: meetingType
                            });
                            editEventResource.save(editEventRequest, function (response) {
                                scope.reset();
                            });
                        }
                    }
                };

                scope.$watch('formType', function(){

                    if(scope.formType){

                        var date,
                            eventEnd;

                        if(scope.contributors.length){
                            scope.contributor = scope.contributors[0];
                        }
                        scope.loaded = false;

                        if(scope.formType === 'add'){
                            date = new Date().clearSeconds();
                            eventEnd = date.addHours(1);
                            var minEventTime = new Date(date.getTime());
                            newEventDatePickerConfig.minDate = new Date();
                            scope.event = {
                                metadata: {
                                    title: '',
                                    contributor: scope.contributor ? ((scope.showUserFullName && scope.contributor.user.firstName !=null && scope.contributor.user.lastName !=null)? scope.contributor.user.firstName + ' ' + scope.contributor.user.lastName : scope.contributor.user.login) : '',
                                    description: '',
                                    destination: scope.parent
                                },
                                dateTimeOptions: {
                                    date: date,
                                    startDate: date,
                                    endDate: eventEnd,
                                    min: minEventTime,
                                    timeZone: scope.dateTimePicker.timeZones[scope.timezoneDefault],
                                    config: newEventDatePickerConfig
                                }
                            };
                            scope.toggleEventForm({status : true});
                        } else if (scope.formType === 'edit'){
                            console.log('editableEvent: ', scope.editableEvent)
                            date = getRemoteDate(scope.editableEvent.startTime, scope.editableEvent.timeZone).clearSeconds();
                            eventEnd = getRemoteDate(scope.editableEvent.endTime, scope.editableEvent.timeZone).clearSeconds();
                            CollectionService.getSingleCollection({
                                cid: scope.editableEvent.destinationCollectionId,
                                type: 'COURSE'
                            }).then(function(destination){
                                scope.event = {
                                    metadata: {
                                        title: scope.editableEvent.eventInfo.title,
                                        contributor: scope.editableEvent.contributor,
                                        description: scope.editableEvent.eventInfo.description,
                                        eventStatus: scope.editableEvent.eventStatus,
                                        destination: destination
                                    },
                                    dateTimeOptions: {
                                        date: date,
                                        startDate: date,
                                        endDate: eventEnd,
                                        timeZone: $filter('filter')(scope.dateTimePicker.timeZones, {key: scope.editableEvent.timeZone}, true)[0],
                                        config: newEventDatePickerConfig
                                    },
                                    meetingOptions: {
                                        meetingId: scope.editableEvent.eventInfo.meetingId,
                                        meetingUuid: scope.editableEvent.eventId,
                                        contributor: scope.editableEvent.eventInfo.contributor,
                                        joinUrl: scope.editableEvent.eventInfo.joinUrl
                                    }
                                };
                                if ([3,8].includes(scope.editableEvent.eventInfo.meetingType)) {
                                    scope.recurring = true;
                                }
                                scope.toggleEventForm({status : true});
                            }).catch(function(err) {
                                scope.error = err;
                                $log.error("An error occurred when trying to fetch collections");
                            });
                        }
                        scope.loaded = true;
                    }

                });

                scope.getSummaryTextTimeout = function () {
                    $timeout(function () {
                        scope.getSummaryText();
                    }, 150);
                }

                scope.$watch('event.dateTimeOptions.date', function(){
                    if(scope.event && scope.event.dateTimeOptions.date){
                        var selectedDate = scope.event.dateTimeOptions.date;
                        SchedulerService.copyDatesWithoutTimeChange(scope.event.dateTimeOptions.startDate, selectedDate);
                        SchedulerService.copyDatesWithoutTimeChange(scope.event.dateTimeOptions.endDate, selectedDate);
                    }
                });

                scope.selectTimeZone = function(timeZone){
                    scope.event.dateTimeOptions.timeZone = timeZone;
                };

                scope.changeDestination = function(destination){
                    scope.event.metadata.destination = destination;
                };

                scope.changeContributor = function(contributor){
                    scope.contributor = contributor;
                    scope.event.metadata.contributor = (scope.showUserFullName && scope.contributor.user.firstName !=null && scope.contributor.user.lastName !=null)? scope.contributor.user.firstName + ' ' + scope.contributor.user.lastName : scope.contributor.user.login;
                };

                scope.checkForEnterKey = function (event, action) {
                    if (event.keyCode === 13) {
                        if (action === "showCancelEventModal") {
                            $("#cancelConfirmation").modal('show');
                        }
                    }
                };

                scope.launchZoom = function () {
                    SchedulerService.OAuth.get({standaloneInstall: false}, function(response){
                        var win = window.open(response.requestUrl, 'Authentication', 'width=972,height=660,modal=yes,alwaysRaised=yes');
                    });
                };
            }
        }
    }]);
